module.exports = __webpack_public_path__ + "static/media/6031.f8e7b67a.png";